import { CalendarContainerProps } from "react-datepicker";
import cns from "classnames";
import { makeStyles } from "@material-ui/core";
import { Color } from "../../../theme/color";

export function DatePickerCustomContainer({
  className,
  children
}: CalendarContainerProps) {
  const classes = useStyles({});

  return <div className={cns(className, classes.container)}>{children}</div>;
}

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: Color.White,
    border: "none !important",
    boxShadow: "1px 6px 24px 0px rgba(128, 128, 128, 0.15)",
    borderRadius: "8px"
  }
}));
